	function ContactFormPropertySourcing(settings){
		this.setup(settings);
	}
	ContactFormPropertySourcing.inheritsFrom( ContactForm );
	ContactFormPropertySourcing.prototype.instructions = function(){
		return {
			pages: [
				{name: "index", 	questions: ['buyrent']}, //,'budget','budget-rental'] },
				{
					name: "questions",
					questions: ['budget'],
					include: (e) => {
						const buyrent = this.values['buyrent'];
						return (buyrent === "buy");
					}
				},
				{
					name: "questions",
					questions: ['budget-rental'],
					include: (e) => {
						const buyrent = this.values['buyrent'];
						return (buyrent === "rent");
					}
				},
				{ 	name: "details1",	questions: ['full-name'],
					include: (e) => {
						const budget = this.values['budget'];
						const budgetrental = this.values['budget-rental'];
						return ((budget != "")||(budgetrental != ""));
					}
				},
				{ 	name: "details2",	questions: ['email'],
					include: (e) => {
						const budget = this.values['budget'];
						const budgetrental = this.values['budget-rental'];
						return ((budget != "")||(budgetrental != ""));
					}
				},
				{ 
					name: "details3",	questions: ['phone'],
					include: (e) => {
						const budget = this.values['budget'];
						const budgetrental = this.values['budget-rental'];
						return ((budget != "")||(budgetrental != ""));
					}
				},
				{ 
					name: "details4",	questions: ['your-requirements'], 
					include: (e) => {
						const budget = this.values['budget'];
						const budgetrental = this.values['budget-rental'];
						return ((budget != "")||(budgetrental != ""));
					}
				}
			],
			questions: [
				{
					name: "buyrent",
					input: "buttons",
					inputType: "single",
					required: true,
					labels: "Are you looking to buy or rent?",
					answers: [
						{ labels: "Buy", 		name: "buy"},
						{ labels: 'Rent', 		name: "rent"}
					],

				},{
					name: "budget",
					input: "buttons",
					inputType: "multiple",
					required: false,
					labels: "What is your budget?",
					//visible: false,
					answers: [
						{ labels: "Undecided", 	name: "undecided"},
						{ labels: '£1-2M', 		name: "£1-2M"},
						{ labels: '£2-5M', 		name: "£2-5M"},
						{ labels: '£5-10M', 	name: "£5-10M"},
						{ labels: '£10-20M', 	name: "£10-20M"},
						{ labels: '£20M+', 		name: "£20M+"}
					],
				},{
					name: "budget-rental",
					input: "buttons",
					inputType: "single",
					required: false,
					labels: "What is your monthly budget?",
					//visible: false,
					answers: [
						{ labels: "Undecided", 	name: "undecided"},
						{ labels: 'up to £5K', 	name: "up to £5K"},
						{ labels: '£6-10K', 	name: "£6-10K"},
						{ labels: '£11-30K', 	name: "£11-30K"},
						{ labels: '£31-50K', 	name: "£31-50K"},
						{ labels: '£50K+', 		name: "£50K+"}
					],
				},
				{
					name: "full-name",
					input: "text",
					required: true,
					labels: "Please tell us your name",
					placeholder: "Type your name here",
				},{
					name: "email",
					input: "text",
					required: false,
					labels: "Please enter your email address",
					placeholder: "Type your email address",
				},{
					name: "phone",
					input: "text",
					required: false,
					labels: "Please enter your phone number",
					placeholder: "Type your phone number",
				},
				{
					name: "your-requirements",
					input: "textarea",
					required: false,
					labels: "Further information you would like to share",
					placeholder: "Type further information here",
				}
			]
		}
	}
